import { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { Loader2, CheckCircle2, XCircle } from "lucide-react";
import { api } from "../lib/api";

export default function WebinairePaiement() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState("checking");
  useEffect(() => {
    const sid = params.get("session_id");
    if (!sid) { setStatus("error"); return; }
    let tries = 0;
    const check = async () => {
      try {
        const { data } = await api.get(`/webinars/pay/confirm?session_id=${sid}`);
        if (data.status === "paid") { setStatus("paid"); setTimeout(() => navigate(`/webinaire/acces/${data.token}`, { replace: true }), 1500); return; }
      } catch { /* ignore */ }
      if (++tries < 8) setTimeout(check, 2000); else setStatus("error");
    };
    check();
  }, []); // eslint-disable-line

  return (
    <div className="mx-auto flex min-h-[50vh] max-w-md flex-col items-center justify-center px-4 text-center" data-testid="webinaire-paiement">
      {status === "checking" && <><Loader2 className="mb-3 animate-spin text-ciel" size={32} /><p className="text-slate-500">Vérification du paiement…</p></>}
      {status === "paid" && <><CheckCircle2 className="mb-3 text-emerald-500" size={40} /><p className="font-semibold text-navy">Paiement confirmé — inscription validée !</p></>}
      {status === "error" && <><XCircle className="mb-3 text-red-500" size={40} /><p className="text-slate-500">Paiement non confirmé. Si vous avez été débité, contactez le secrétariat.</p></>}
    </div>
  );
}
